'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { ESCAPE_KEYCODE } from '../../util/keycodes.js';
import { Button } from '../Button/Button.js';
import { Dropdown } from '../Dropdown/Dropdown.js';
import { Drawer } from '../Drawer/index.js';
import { Heading } from '../Heading/Heading.js';
export const ButtonDropdown = (_a) => {
    var { ariaLabelledBy, behavior, buttonText, children, className, drawerTitle, size, variant, titleAfter, iconPosition = 'after', iconName = 'chevron-down', onStateChange } = _a, other = __rest(_a, ["ariaLabelledBy", "behavior", "buttonText", "children", "className", "drawerTitle", "size", "variant", "titleAfter", "iconPosition", "iconName", "onStateChange"]);
    const ref = React.useRef(null);
    const buttonRef = React.useRef(null);
    const [isActiveVar, setIsActive] = React.useState(false);
    React.useEffect(() => {
        if (typeof onStateChange === 'function') {
            onStateChange(isActiveVar);
        }
    }, [isActiveVar]);
    React.useEffect(() => {
        if (isActiveVar) {
            if (!ref.current)
                return;
            const el = ref.current.querySelector('.sparky-c-dropdown');
            if (el)
                el.focus();
        }
        document.addEventListener('mousedown', handleOnClickOutside, false);
        document.addEventListener('touchstart', handleOnClickOutside, false);
        return () => {
            document.removeEventListener('mousedown', handleOnClickOutside, false);
            document.removeEventListener('touchstart', handleOnClickOutside, false);
        };
    });
    const handleOnClickOutside = (event) => {
        if (behavior !== 'responsive' &&
            ref.current &&
            !ref.current.contains(event.target) &&
            buttonRef.current &&
            !buttonRef.current.contains(event.target)) {
            closePanel();
            setTimeout(() => {
                var _a;
                (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }, 2);
        }
        else if (behavior === 'responsive' &&
            window.innerWidth >= 768 &&
            ref.current &&
            !ref.current.contains(event.target) &&
            buttonRef.current &&
            !buttonRef.current.contains(event.target)) {
            closePanel();
            setTimeout(() => {
                var _a;
                (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }, 2);
        }
    };
    function closePanel() {
        setIsActive(false);
        setTimeout(() => {
            if (isActiveVar && buttonRef.current) {
                buttonRef.current.focus();
            }
        }, 1);
    }
    function handleKeyDown(e) {
        if (e.code === ESCAPE_KEYCODE) {
            closePanel();
        }
    }
    function togglePanel() {
        setIsActive(!isActiveVar);
    }
    const componentClassName = classnames('sparky-c-button-dropdown', className, {
        'sparky-is-active': isActiveVar === true,
        'sparky-c-button-dropdown--responsive': behavior === 'responsive',
    });
    return (_jsxs("div", Object.assign({ className: componentClassName, ref: ref, onKeyDown: (e) => handleKeyDown(e) }, other, { children: [_jsx(Button, { className: "sparky-c-button-dropdown__button", size: size, variant: variant, text: buttonText, onClick: togglePanel, buttonRef: buttonRef, "aria-expanded": isActiveVar ? true : false, iconPosition: iconPosition, iconName: iconName }), _jsx(Dropdown, Object.assign({ className: "sparky-c-button-dropdown__panel" }, { children: children })), behavior === 'responsive' && (_jsxs(Drawer, Object.assign({ className: "sparky-c-button-dropdown__drawer", onClose: togglePanel, align: "bottom", isActive: isActiveVar, ariaLabelledBy: ariaLabelledBy }, { children: [_jsx(Drawer.Header, Object.assign({ backButtonIcon: "chevron-left", closeButtonText: "Close", titleAfter: titleAfter }, { children: _jsx(Heading, Object.assign({ id: ariaLabelledBy, tagName: "h2", size: "title" }, { children: drawerTitle })) })), _jsx(Drawer.Body, { children: children })] })))] })));
};
//# sourceMappingURL=ButtonDropdown.js.map